import { render, staticRenderFns } from "./AgreementCoinRecords.vue?vue&type=template&id=0f30e534&scoped=true"
import script from "./AgreementCoinRecords.vue?vue&type=script&lang=js"
export * from "./AgreementCoinRecords.vue?vue&type=script&lang=js"
import style0 from "./AgreementCoinRecords.vue?vue&type=style&index=0&id=0f30e534&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f30e534",
  null
  
)

export default component.exports